module.exports = __webpack_public_path__ + "static/Srinivasa-5-df41fddff7a69f3eadc5d18f5b2bf354.jpeg";